<template>
  <div class="organism-all-event-filter_container row">
    <div class="col-12 col-lg-6 w-100 pb-1">
      <molecule-date-picker-period
        titleStart="Start Date"
        titleEnd="End Date"
        type="dateNtime"
        v-model="datepicker"
        :maxDate="datepicker.end"
        :minDate="datepicker.start"
        :dateNow="datepicker.now"
      ></molecule-date-picker-period>
    </div>
    <div class="px-1 col-12 col-lg-6">
      <label>Equipment Name</label>
      <atom-multi-select
        v-model="selectedEquipmentList"
        :option="equipmentList"
        :isDisable="false"
        :isAppendToBody="false"
        :isEnableProper="false"
        placeholder="All Equipments"
        class="w-100"
      ></atom-multi-select>
    </div>
    <div class="px-1 col-12 col-lg-6 mt-1 mt-lg-0">
      <label>Tag</label>
      <atom-multi-select
        v-model="selectedTagList"
        :option="tagList"
        :isDisable="false"
        :isAppendToBody="false"
        :isEnableProper="false"
        placeholder="All Tags"
      ></atom-multi-select>
    </div>
    <div class="col-12 col-lg-6 mt-1 mt-lg-0">
      <div class="d-flex justify-content-between">
        <div class="container__resource-type">
          <label>Resource Type</label>
          <atom-multi-select
            v-model="selectedResourceList"
            :option="resourceTypeList"
            :isDisable="false"
            :isAppendToBody="false"
            :isEnableProper="false"
            placeholder="All Resource Types"
          ></atom-multi-select>
        </div>
        <div class="container__button-filter">
          <atom-button
            buttonId="button-search"
            iconLeft="SearchIcon"
            @click="filterButtonClick"
            class="search__button ml-2"
          ></atom-button>
          <div class="reset-filter-button ml-1" @click="clickButtonClearFilter">
            <span>Reset</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomMultiSelect from "@/components/atoms/AtomMultiSelect.vue"
import MoleculeDatePickerPeriod from "@/components/molecules/MoleculeDatePickerPeriod.vue"
export default {
  name: "OrganismAllEventFilter",
  components: {
    MoleculeDatePickerPeriod,
    AtomMultiSelect,
    AtomButton,
  },
  props: {
    equipmentList: {
      type: Array,
      required: true,
    },
    tagList: {
      type: Array,
      required: true,
    },
    resourceTypeList: {
      type: Array,
      required: true,
    },
    filterList: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  emits: ["clickFilter"],
  data() {
    return {
      selectedEquipmentList: [],
      selectedTagList: [],
      selectedResourceList: [],
    }
  },
  computed: {
    datepicker: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },
  },
  watch: {
    filterList: {
      deep: true,
      immediate: true,
      handler() {
        this.datepicker.start = this.filterList.from
        this.datepicker.end = this.filterList.to
        this.datepicker.now = this.filterList.to
        this.selectedEquipmentList = this.filterList.equipments
        this.selectedResourceList = this.filterList.resourceTypes
        this.selectedTagList = this.filterList.tags
      },
    },
  },
  methods: {
    filterButtonClick() {
      let filter = {
        from: this.datepicker.start,
        to: this.datepicker.end,
        equipments: this.selectedEquipmentList?.length
          ? this.selectedEquipmentList
          : [],
        tags: this.selectedTagList?.length ? this.selectedTagList : [],
        resourceTypes: this.selectedResourceList?.length
          ? this.selectedResourceList
          : [],
      }
      this.$emit("clickFilter", filter)
    },

    clickButtonClearFilter() {
      this.$emit("onSetDefaultFilterData")
    },
  },
}
</script>

<style lang="scss" scoped>
.container__resource-type {
  width: 100%;
}

.container__button-filter {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  width: 130px;
  height: 38px;
  margin-top: 23px;
}

.button__container {
  margin-top: 1.65rem;
}

.modal-edit-tag__dropdown {
  width: 100%;
}

.reset-filter-button {
  color: #B9B9C3;
  margin-bottom: 8px;
  text-decoration: underline;
  &:hover {
    cursor: pointer;
    color: #7367F0;
  }
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
  .overwrite__container {
    width: 395px;
  }
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
